function getMembershipOrganization(membership: unknown) {
  if (!membership || typeof membership !== 'object') {
    return null;
  }

  const candidate = membership as {
    organization?: { id?: string; name?: string | null; slug?: string | null };
    publicOrganizationData?: { id?: string; name?: string | null; slug?: string | null };
  };
  return candidate.organization || candidate.publicOrganizationData || null;
}

function formatOrganizationSlug(slug?: string | null) {
  return slug ? slug.replace(/-/g, ' ') : undefined;
}

export function getActiveOrganizationContext({
  memberships,
  organization,
  sessionOrganizationId,
}: {
  memberships: unknown[];
  organization?: { id?: string; name?: string | null; slug?: string | null } | null;
  sessionOrganizationId?: string | null;
}) {
  const singleMembershipOrganization =
    memberships.length === 1 ? getMembershipOrganization(memberships[0]) : null;
  const organizationId =
    organization?.id || sessionOrganizationId || singleMembershipOrganization?.id;
  const membershipOrganization = organizationId
    ? memberships
        .map(getMembershipOrganization)
        .find((membershipOrg) => membershipOrg?.id === organizationId)
    : singleMembershipOrganization;
  const organizationName =
    organization?.name ||
    membershipOrganization?.name ||
    formatOrganizationSlug(organization?.slug) ||
    formatOrganizationSlug(membershipOrganization?.slug);

  return {
    organizationId,
    organizationName,
  };
}
